import { render } from "./flashSale.vue?vue&type=template&id=00f7079a"
import script from "./flashSale.vue?vue&type=script&lang=js"
export * from "./flashSale.vue?vue&type=script&lang=js"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__